import { useRouter } from 'next/router';
import { useState, useEffect, useContext } from 'react';
import PageContext from '@contexts/PageContext';
import { Container, Button } from '@components';
import { ArticlePreview } from '@containers';
import styles from './FeaturedChildren.module.scss';
import ReactPaginate from 'react-paginate';
import {checkEnabled} from '@components/OptionalFeature';

const FeaturedChildren = ({ data, componentIsAvailable, showTitle, componentTitle }) => {
  const router = useRouter();
  const { locale } = router;
  const pageData = useContext(PageContext);
  const { DisplayOptions } = data;
  const { Children } = pageData;


  //show buttonText
  const showButtonText = checkEnabled(DisplayOptions,'ButtonText');

  //check Count
  const count = DisplayOptions?.find((item) => item.DisplayOptionKey === 'Count').OptionInformation;

  //Children content
  const childrenData = Children?.map((child) => child.p);

  //image check   
   const imageEnabled = checkEnabled(DisplayOptions, 'BackgroundHero');

  return (
    componentIsAvailable && (
      <section className={styles.Section}>
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          <div className={count != 1 ? styles.Double : styles.FullWidth}>
            {childrenData.slice(0, count).map((post) => (
              <ArticlePreview imageEnabled={imageEnabled} key={post.PostId} data={post} showButtonText={showButtonText} LinkOutEnabled={true} />
            ))}
          </div>
        </Container>
      </section>
    )
  );
};

export default FeaturedChildren;
